import React from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from '@material-ui/core'
//import CloseIcon from '@material-ui/icons/Close'
//import IconButton from '@material-ui/core/IconButton'

import Title from 'components/CommonUI/Title/Title'
import Button from 'components/CommonUI/Button/Button'

import { useShallowEqualSelector } from 'custom-hooks/useShallowEqualSelector'
import {
  closeConfirmationModal,
  getIsShowSelector,
  getModalDataSelector,
  callYes,
} from 'redux/reducers/confirmationModal'

const ConfirmationDialogModal = () => {
  const dispatch = useDispatch()
  const {
    title = '',
    description = '',
    leftButtonTitle = '',
    rightButtonTitle = 'Cancel',
    cancelButton = 'right',
  } = useShallowEqualSelector(getModalDataSelector) || {}

  const handleLeftButton = () => {
    if (cancelButton === 'left') {
      dispatch(closeConfirmationModal())
      return
    }
    dispatch(callYes())
  }

  const handleRightButton = () => {
    if (cancelButton === 'right') {
      dispatch(closeConfirmationModal())
      return
    }
    dispatch(callYes())
  }

  const styleButton = (side) => ({
    variant: cancelButton === side ? 'outlined' : 'contained',
    color: cancelButton === side ? 'secondary' : 'primary',
  })

  return (
    <Modal className="confirmation_modal" open={true}>
      <div className="confirmation_modal_dialog">
        <div className="title_section">
          <Title title={title} component="h3" className="title" />
          {/* <IconButton className="close_button">
            <CloseIcon />
          </IconButton> */}
        </div>
        <div className="body_section">
          <span className="description">{description}</span>
          <div className="buttons_group">
            <Button
              className="button yes_button"
              onClick={handleLeftButton}
              {...styleButton('right')}
            >
              {leftButtonTitle}
            </Button>
            <Button
              className="button cancel_button"
              onClick={handleRightButton}
              {...styleButton('left')}
            >
              {rightButtonTitle}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

const ConfirmationDialogContainer = () => {
  const isShow = useShallowEqualSelector(getIsShowSelector)
  return isShow ? <ConfirmationDialogModal /> : null
}

export default ConfirmationDialogContainer
